// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.authStatus = 'loading'
  },
  auth_success (state, [token, refreshToken, tokenExpiration]) {
    state.authStatus = 'success'
    state.token = token
    state.refreshToken = refreshToken
    state.tokenExpiration = tokenExpiration
  },
  auth_error (state) {
    state.authStatus = 'error'
  },
  logout (state) {
    state.authStatus = ''
    state.token = ''
    state.refreshToken = ''
    state.tokenExpiration = ''

    state.permissions = []
    state.currentUser = {}
    state.currentPerson = {}
    state.currentEmployee = {}

    state.isMyProfile = true
    sessionStorage.clear()
  },
  current_user_request (state, currentUser) {
    state.currentUser = currentUser
    state.currentPerson = currentUser.person
    state.currentEmployee = currentUser.employee
  },
  user_permissions_request (state, permissions) {
    state.permissions = permissions
  },
  update_person_request (state, person) {
    Object.keys(person).map(key => {
      state.currentPerson[key] = person[key]
    })
  },
  user_last_login_request () {
  },
  organization (state, organization) {
    state.organization = organization
  },
}
